import { render } from "./PowderSavingsResults.vue?vue&type=template&id=2a985466&scoped=true"
import script from "./PowderSavingsResults.vue?vue&type=script&lang=js"
export * from "./PowderSavingsResults.vue?vue&type=script&lang=js"

import "./PowderSavingsResults.vue?vue&type=style&index=0&id=2a985466&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./PowderSavingsResults.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a985466"]])

export default __exports__